/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core';
import Button from 'components/Button';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

interface DialogPropTypes {
  extendSession: () => void;
  endSession: () => void;
}

const TimeoutDialog: React.FC<DialogPropTypes> = props => {
  const { extendSession, endSession } = props;
  const tMd = useMarkdownTranslate();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="timeout-warning-dialog-title"
      open={true}
    >
      <DialogTitle id="timeout-warning-dialog-title">
        {tMd('appTimeout.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{tMd('appTimeout.warning')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={endSession}>
          {tMd('appTimeout.cancel')}
        </Button>
        <Button variant="text" autoFocus onClick={extendSession}>
          {tMd('appTimeout.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

interface PropTypes {
  warned: boolean;
  extendSession: () => void;
  endSession: () => void;
}
const AppTimeoutModalView: React.FC<PropTypes> = props => {
  const { warned, extendSession, endSession } = props;
  return (
    <React.Fragment>
      {warned && (
        <TimeoutDialog extendSession={extendSession} endSession={endSession} />
      )}
      {props.children}
    </React.Fragment>
  );
};

export default AppTimeoutModalView;
